import { Highlight } from '../Highlight';
import { CellRenderer, CellRenderProps, CellValue } from '../types';

import { DocumentFileLink, isViewableDocument } from './DocumentFileLink';
import styles from './plain.module.scss';

const isEmpty = (value: CellValue): boolean => value === null || value === undefined || value === '';

const toText = (value: CellValue): string => (typeof value === 'object' ? JSON.stringify(value) : String(value));

const EmptyCell = () => (
  <span
    className={styles.emptyCell}
    title="No value in this row"
  >
    —
  </span>
);

const Compact = ({ value }: CellRenderProps) => {
  if (isEmpty(value)) return <EmptyCell />;
  return (
    <span className={styles.compact}>
      <Highlight text={toText(value)} />
    </span>
  );
};

const Expanded = ({ value }: CellRenderProps) => {
  if (isEmpty(value)) return <EmptyCell />;
  const text = toText(value);
  return (
    <span>
      <Highlight text={text} />
      {isViewableDocument(text) && <DocumentFileLink filename={text} />}
    </span>
  );
};

const Full = ({ value }: CellRenderProps) => {
  if (isEmpty(value)) return <EmptyCell />;
  const text = toText(value);
  return (
    <span>
      <Highlight text={text} />
      {isViewableDocument(text) && <DocumentFileLink filename={text} />}
    </span>
  );
};

export const plainRenderer: CellRenderer = {
  kind: 'plain',
  detect: () => true,
  Compact,
  Expanded,
  Full,
};
